import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-screen w-screen overflow-auto p-3 lg:p-8 bg-secondary flex flex-col text-white" }
const _hoisted_2 = { class: "pl-2 pr-2 md:pl-16 md:pr-16 lg:pl-32 lg:pr-32" }

import { IconsName } from "@/utils/icons";
import Page from "@/utils/pages";
import Heading from "../atoms/Heading.vue";
import CloseButton from "../atoms/CloseButton.vue";
import { Motion } from "motion/vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    icon: null
  },
  setup(__props: any) {

const router = useRouter();
const pageName = computed(() => (router.currentRoute.value.name as Page) || "");

const { t } = useI18n();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Motion), {
      class: "relative flex lg:pb-12 md:pb-8 pb-4",
      initial: {
        translateY: -300,
      },
      animate: {
        translateY: 0,
      },
      transition: {
        duration: 0.8,
        easing: 'ease-out',
      }
    }, {
      default: _withCtx(() => [
        _createVNode(CloseButton, {
          onClick: _cache[0] || (_cache[0] = () => _unref(router).push({ name: _unref(Page).Home })),
          class: "top-0 l-0 absolute"
        }),
        _createVNode(Heading, {
          class: "flex-1",
          icon: __props.icon
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)(`${_unref(pageName)}.header`)), 1)
          ]),
          _: 1
        }, 8, ["icon"])
      ]),
      _: 1
    }, 8, ["transition"]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})